import { render } from "./SlowSpansPanel.vue?vue&type=template&id=2906495a"
import script from "./SlowSpansPanel.vue?vue&type=script&lang=js"
export * from "./SlowSpansPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__